import ADILiveChatComponent from "@NA/Components/ADILiveChatComponent";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StyledButton } from "@insite/mobius/Clickable";
import LazyImage, { LazyImageStyle } from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface ADINoSearchContactUsStyles {
    noSearchContactUsContainer?: InjectableCss;
    telephoneStyles?: InjectableCss;
}

export const adiNoSearchContactUsStyles: ADINoSearchContactUsStyles = {
    noSearchContactUsContainer: {
        css: css`
        text-align: center;
        margin-bottom: 52px;
        padding: 10px 20px 0px;
        background-color: ${ADIColors.gray6};
        border-radius: 4px;
        @media only screen and (max-width: 700px) {
            margin-bottom: 20px;
        }
        >${LazyImageStyle}{
            margin: 10px 0px 0px 0px;
        }
        >h1{
            font-weight: 700;
            margin: 0px 0px 5px 0px;
            line-height: 1.25em;
            color: ${ADIColors.darkBlue1};
            font-size: 24px;
            @media only screen and (max-width: 1080px) {
                font-size: 20px;
            }
        }
        .contactUsLinkText{
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: center;
            padding: 8px 0px 24px 0px;
            >${StyledButton}{
                font-weight: 700;
                font-size: 14px;
                >${TypographyStyle}{
                    &:hover{
                        color: ${getColor("primary")};
                        text-decoration: underline;
                    }
                }
            }
        }
        `
    },
    telephoneStyles: {
        css: css`
        color: ${ADIColors.darkBlack2};
        font-weight: normal; 
        font-size: 14px;
        line-height: 1.6;
        >${StyledButton}{
            >${TypographyStyle}{
                color: ${ADIColors.darkBlack2};
                &:hover{
                    color: ${ADIColors.darkBlack2};
                    text-decoration: underline;
                }
            }
        }
        `
    }
};

const styles = adiNoSearchContactUsStyles;

const ADINoSearchContactUs = ({ id }: Props) => {
    return (
        <StyledWrapper {...styles.noSearchContactUsContainer}>
            <LazyImage src={`https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/svg/contact-us.svg`} />
            <Typography as="h1">{translate("Contact Us")}</Typography>
            <Typography as="p" {...styles.telephoneStyles}>{translate("Website Support:")} <Link href="tel:1.877.228.6739">{translate("1.877.228.6739")}</Link></Typography>
            <Typography as="p" {...styles.telephoneStyles}>{translate("Systems Design:")} <Link href="tel:1.800.234.7971">{translate("1.800.234.7971")}</Link></Typography>
            <ADILiveChatComponent adiNoSearchContactUs={true} />
            <StyledWrapper className="contactUsLinkText">
                <Link href="/ContactUs">{translate("Contact Us")}</Link>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ADINoSearchContactUs,
    definition: {
        group: "Common",
        displayName: "ADI No Search Contact Us",
    },
};

export default widgetModule;
